import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JucIaComponent } from './juc-ia/juc-ia.component';
import { JucComponent } from './juc.component';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from '../core/core.module';
import { VendorModule } from '../core/vendor.module';
import { SharedComponentsModule } from '../shared-components/shared-components.module';
import { SharedServicesModule } from '../shared-services/shared-services.module';
import { SecurityModule } from '../security/security.module';
import { SlideshowModule } from 'ng-simple-slideshow';
import { NgxMaskModule } from 'ngx-mask';
import { QuillEditorModule } from 'ngx-quill-editor';
import { SecurityService } from '../security/security.service';
import { LoguedGuardService } from '../security/logued-guard.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CoreModule,
    VendorModule,
    SharedComponentsModule,
    SharedServicesModule,
    SecurityModule,
    SlideshowModule,
    QuillEditorModule,
    NgxMaskModule,
  ],
  declarations: [JucIaComponent,
    JucComponent],
    exports: [
      JucIaComponent,
    JucComponent
    ],
    providers: [
      SecurityService,
      LoguedGuardService,
    ]
})
export class JucModule { }



// WEBPACK FOOTER //
// ./src/app/juc/juc.module.ts